import { typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { getLinkCustomerGuestyUrl } from "./api-url.constants";
import { LinkCustomerGuestyError } from "./errors";

interface LinkCustomerGuestyBody {
  integrationToken: string;
  userId?: string;
}

export const linkCustomerGuesty = async ({
  integrationToken,
  userId,
}: LinkCustomerGuestyBody): Promise<void> => {
  const response = await typedFetch(getLinkCustomerGuestyUrl(userId), {
    method: API_METHODS.POST,
    body: JSON.stringify({
      integrationToken,
    }),
  });

  if (!response.ok) throw new LinkCustomerGuestyError();
};
